import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { Button } from 'antd';
import { useHistory } from 'react-router-dom';

import { userFacebookSignIn, userGoogleSignIn } from 'appRedux/actions/Auth';
import IntlMessages from 'util/IntlMessages';

import styles from './styles.module.less';
import { ReactComponent as GoogleIcon } from './assets/logo_google.svg';
import { ReactComponent as FacebookIcon } from './assets/logo_facebook.svg';

const SocialSignIn = ({ disabled }) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const handleGoogleSignIn = () => {
    dispatch(userGoogleSignIn());
  };

  const handleFacebookSignIn = () => {
    dispatch(userFacebookSignIn());
  };

  const IconLabel = ({ icon, label }) => (
    <div className={styles.buttonChildren}>
      <div className="gx-flex-row gx-align-items-center">{icon}</div>
      <div className="gx-flex-row gx-align-items-center gx-mt-1">{label}</div>
    </div>
  );

  return (
    <div className={styles.socialStack}>
      <Button
        className={styles.socialOption}
        disabled={disabled}
        htmlType="button"
        onClick={handleGoogleSignIn}
      >
        <div className="gx-flex-row gx-justify-content-center gx-align-items-center gx-w-100 gx-guarnic-gap-2">
          <IconLabel
            icon={<GoogleIcon aria-hidden focusable="false" />}
            label={<IntlMessages id="auth.socialSignIn.google" />}
          />
        </div>
      </Button>
      <Button
        className={styles.socialOption}
        disabled={disabled}
        htmlType="button"
        onClick={handleFacebookSignIn}
      >
        <div className="gx-flex-row gx-justify-content-center gx-align-items-center gx-w-100 gx-guarnic-gap-2">
          <IconLabel
            icon={<FacebookIcon aria-hidden focusable="false" />}
            label={<IntlMessages id="auth.socialSignIn.facebook" />}
          />
        </div>
      </Button>
      <Button
        className={styles.socialOption}
        disabled={disabled}
        htmlType="button"
        onClick={() => history.push('/email_link')}
      >
        <div className="gx-flex-row gx-justify-content-center gx-align-items-center gx-w-100 gx-guarnic-gap-2">
          <div className={styles.buttonChildren}>
            <div className="gx-flex-row gx-align-items-center">
              <span className="material-symbols-outlined" aria-hidden>
                mail_lock
              </span>
            </div>
            <div className="gx-flex-row gx-align-items-center">
              <IntlMessages id="auth.emailLink" />
            </div>
          </div>
        </div>
      </Button>
    </div>
  );
};

SocialSignIn.propTypes = {
  disabled: PropTypes.bool,
};

SocialSignIn.defaultProps = {
  disabled: false,
};

export default React.memo(SocialSignIn);
